import { WizNativeDateAdapter } from './../../../services/date/wiz-native-date-adapter';
import { WizTimefield } from './wiz-timefield/wiz-timefield';
import { WizTimepicker } from './wiz-timepicker/wiz-timepicker';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgModule } from '@angular/core';
import { WizDateField } from './wiz-datefield/wiz-datefield';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WizLayoutModule } from '../../layouts/wiz-layout.module';
import { WizLabelModule } from '../wiz-label/wiz-label.module';
import { WizStylingDirectiveModule } from '../../../directives/styling/wiz-styling-directives.module';
import { WizButtonModule } from '../button/wiz-button.module';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WizBehaviorDirectiveModule } from '../../../directives/behavior/wiz-behavior-directives.module';
import { MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { WizMatDatepicker } from './wiz-calendar/wiz-mat-datepicker';
import { WizInputModule } from '../input/wiz-input.module';
import { WizIconModule } from '../wiz-icon/wiz-icon.module';
@NgModule({
  declarations: [WizDateField, WizTimepicker, WizTimefield, WizMatDatepicker],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    ScrollingModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    MatInputModule,
    WizLabelModule,
    WizLayoutModule,
    WizStylingDirectiveModule,
    WizButtonModule,
    A11yModule,
    WizBehaviorDirectiveModule,
    MatSelectModule,
    WizInputModule,
    WizIconModule
  ],
  providers: [
    // Date adapter custom pour gestion de la saisie manuelle et du rendu
    { provide: DateAdapter, useClass: WizNativeDateAdapter }
  ],
  exports: [MatDatepickerModule, MatNativeDateModule, WizDateField, WizTimepicker, WizTimefield]
})
export class WizDateModule { }
